import React, { useMemo } from 'react';
import { View, StyleSheet } from 'react-native';
import { rem } from 'design-system';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { RewardPreView } from 'features/rewards/components/RewardPreView';
import { isWeb } from '../../../constants';
export const RewardImageBackgroundGroup = React.memo(({ rewards, onRewardSelect }) => {
    const { width } = useAppFrameDimensions(isWeb);
    const rewardStyle = useMemo(() => [
        styles.reward,
        {
            width: 0.25 * (width - rem(32)),
        },
    ], [width]);
    return (<View style={styles.container}>
        {rewards.map((reward) => (<View style={rewardStyle} key={reward.id}>
            <RewardPreView largerText reward={reward} onPress={onRewardSelect} style={styles.rewardPreview}/>
          </View>))}
      </View>);
});
const styles = StyleSheet.create({
    container: {
        flexWrap: 'wrap',
        flexDirection: 'row',
        paddingVertical: rem(8),
    },
    reward: {
        alignItems: 'center',
    },
    rewardPreview: {
        marginRight: 0,
    },
});
